import { Link as MuiLink, LinkProps } from '@mui/material'
import { Link, GatsbyLinkProps } from 'gatsby'
import React, { PropsWithChildren } from 'react'

type Props = PropsWithChildren<LinkProps & GatsbyLinkProps<unknown>>

export const BaseTextLink: React.FC<Props> = ({
  children,
  className,
  color,
  to,
  underline,
  variant,
  target,
  sx,
}) => (
  <MuiLink
    className={className}
    color={color}
    to={to}
    component={Link}
    underline={underline ?? 'none'}
    variant={variant ?? 'body1'}
    target={target}
    sx={{
      cursor: 'pointer',
      '&:hover': { opacity: '.6', transition: '.2s' },
      ...sx,
    }}
  >
    {children}
  </MuiLink>
)
